
<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.30895 11.7516C7.68764 11.4315 8.26614 11.4654 8.60107 11.8273L10.2288 13.586L15.6275 8.2658C15.9794 7.91897 16.5589 7.91045 16.9219 8.24677C17.2848 8.58308 17.2937 9.13687 16.9418 9.4837L10.167 16.16L7.22972 12.9863C6.89479 12.6245 6.93026 12.0717 7.30895 11.7516Z"
    :fill="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
    :fill="color"
  />
</svg>
